const FEATURE_FLAG_PRESCRIPTION_ADDITIONAL_FIELDS = false;

type FEATURE_FLAG_PRESCRIPTION_ADDITIONAL_FIELDS = typeof FEATURE_FLAG_PRESCRIPTION_ADDITIONAL_FIELDS;

export default FEATURE_FLAG_PRESCRIPTION_ADDITIONAL_FIELDS;